import React, { useContext, useEffect, useRef, useState } from "react";
import "./New.scss";
import Banner from "./assets/new_imgs/Group 38650.png";
import Food from "./assets/new_imgs/FB.jpg";
import Sevices from "./assets/new_imgs/Group 38654.png";
import HotelServicesImage from "./assets/new_imgs/hotelServices.png";
import HotelServicesKSAImage from "./assets/new_imgs/HS_KSA.png";
import Activities from "./assets/images/Activities2.jpg";
import Taxi from "./assets/new_imgs/Group 38651.png";
import Bed from "./assets/new_imgs/Group 38655.png";
import Spa from "./assets/new_imgs/SPA1.jpg";
import axios from "./axios";
import axioss from "axios";
import Rectangle from "./assets/new_imgs/Rectangle 1072.png";
import Cityguide from "./assets/new_imgs/cityguide.png";
import Hoteinfo from "./assets/new_imgs/hotelinfo.png";
import Dining from "./assets/new_imgs/Dining.png";
import Booking from "./assets/new_imgs/booking.png";

import { Toast } from "primereact/toast";
import NewFooter from "./NewFooter";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ShowHomeMenu } from "./API/HomeMenuAPI";
import BannerHome from "./new-components/banner-home/BannerHome";
import NewLoader from "./new-components/title/Loader/NewLoader";
import { useTranslation } from "react-i18next";
import { ReactTyped } from "react-typed";

import { Zoom, Bounce } from "react-reveal";
import { Button, Modal } from "react-bootstrap";
import { ThemeContext } from "./context/ThemeContext";

import ServiceImage from "./assets/new_imgs/ServiceImage.jpg";
import Overllay from "./assets/new_imgs/Rectangle 1072.png";
import Sustainability from "./assets/new_imgs/Sustainability.jpg";

import News from "./assets/new_imgs/News1.jpg";
import { trackLanguageChanged } from "./utils/mixpanel";
import FlexiDark from "./assets/images/Flexi-Dark.png";
import Flexi from "./assets/images/Flexi.png";
import FoodServiceImage from "./assets/new_imgs/Food.png";
import ExternalServiceImage from "./assets/new_imgs/external.png";
import ENewsServiceImage from "./assets/new_imgs/E-news.png";
const NewHome = () => {
  const { t, i18n } = useTranslation();
  const lang = localStorage.getItem("lang" || "EN");
  const welcomeMessage = localStorage.getItem("welcome_message");

  const [quickServices, setquickServices] = useState([]);
  const [open, setOpen] = useState(false);
  const [serviceId, setServiceId] = useState(null);
  const [loading, setLoading] = useState(false);
  const toast = useRef(null);
  const [countryCode, setCountryCode] = useState("");
  const [popupOpen, setPopupOpen] = useState(false);
  const [popupMedia, setPopupMedia] = useState({ type: null, src: null });
  const businessName = localStorage.getItem("business_name");
  const active_flexipass = localStorage.getItem("active_flexipass");

  const { theme, setTheme } = useContext(ThemeContext);
  console.log("themethemethemethemethemetheme", theme);

  const handleClose = () => {
    setOpen(false);
    setServiceId(null);
  };
  const selectQuickService = (service_id) => {
    setOpen(true);
    setServiceId(service_id);
  };

  const [doorLoading, setDoorLoading] = useState(false);
  const [doorConfirmOpen, setDoorConfirmOpen] = useState(false);

  const unlockDoor = () => {
    setDoorConfirmOpen(false);
    setDoorLoading(true);
    axios
      .post(`/${params.room_uuid}/flexipass/open-door`)
      .then((res) => {
        setDoorLoading(false);
        if (res.data.status === false) {
          toast.current.show({
            severity: "error",
            summary: t("Error"),
            detail: t(res.data.message || "Failed to unlock door."),
            life: 4000,
          });
        } else {
          const result = res.data.data?.[0];
          if (result?.openingSuccess) {
            toast.current.show({
              severity: "success",
              summary: t("Success"),
              detail: t("Door unlocked successfully"),
              life: 4000,
            });
          } else {
            toast.current.show({
              severity: "warn",
              summary: t("Warning"),
              detail: t(
                "Could not unlock the door. Please try again or contact the front desk.",
              ),
              life: 5000,
            });
          }
        }
      })
      .catch(() => {
        setDoorLoading(false);
        toast.current.show({
          severity: "error",
          summary: t("Error"),
          detail: t("Failed to unlock door. Please try again."),
          life: 4000,
        });
      });
  };

  const bookQuickService = () => {
    setLoading(true);

    axios
      .post(
        `/${params.room_uuid}/quick-services/book-service`,
        { service: serviceId },
        {
          headers: {
            lang: lang,
          },
        },
      )
      .then((res) => {
        setLoading(false);

        // if (res.data.status == false) {
        toast.current.show({
          severity: "success",
          summary: t("Success"),
          detail: t(`${res.data.data.message}`),
          life: 4000,
        });

        setOpen(false);
        // }
      })
      .catch((err) => {
        setLoading(false);
      });
  };
  let isOneArrayContentItems = false;

  const settings = {
    dots: true,
    infinite: isOneArrayContentItems ? false : true,
    speed: 100,
    arrows: false,
    slidesToShow: 1.8,
    leftMode: true,
    slidesToScroll: isOneArrayContentItems ? 0 : 1,
    autoplay: false,
    autoplaySpeed: 2000,
    rtl: lang == "AR" ? true : false,
    initialSlide: lang == "AR" ? 2 : 0,
  };
  const params = useParams();
  const navigate = useNavigate();
  const open_lang = localStorage.getItem("open_lang") || "true";
  const [showServices, setShowServices] = useState(false);
  const [openLang, setOpenLang] = useState(open_lang);
  const [showSelect, setShowSelect] = useState(true);
  const { data, isLoading, error } = ShowHomeMenu(params.room_uuid, lang);

  const [showContent, setShowContent] = useState(true);

  let languages;
  let headerImages;
  let services;
  let logo;
  let spaWellnessService;
  let hotelService;
  let hotelServicesCardImage = Sevices;
  let foodService;
  let externalService;
  let activitiesService;
  let eSimService;
  let hotelInformation;
  let displayQuickServices;
  let newsService;
  let sustainablityService;

  if (!isLoading) {
    if (data.data.status === false) {
      navigate(`/${params.room_uuid}/qr-scan`);
    } else {
      const menu = data.data.data;
      languages = data?.data?.data?.Languages;
      setTheme(data?.data?.data?.use_new_design);
      if (data?.data?.data?.welcome_message) {
        localStorage.setItem(
          "welcome_message",
          data?.data?.data?.welcome_message,
        );
      }
      services = data?.data?.data?.activeServices;
      newsService = data?.data?.data?.activeServices?.find(
        (service) => service.id === 25,
      );
      sustainablityService = data?.data?.data?.activeServices?.find(
        (service) => service.id === 33,
      );

      hotelInformation = data?.data?.data?.activeServices?.find(
        (service) => service.id === 0,
      );
      logo = data?.data?.data?.logo;
      localStorage.setItem(
        "countryCode",
        data?.data?.data?.country_code || "ae",
      );
      if (localStorage.getItem("countryCode")?.toUpperCase() === "SA") {
        hotelServicesCardImage = HotelServicesKSAImage;
      }

      spaWellnessService = data?.data?.data?.activeServices?.find(
        (service) => service.id === 4 || service.id === 17 || service.id === 18,
      );

      hotelService = data?.data?.data?.activeServices?.find(
        (service) =>
          service.id === 3 ||
          service.id === 5 ||
          service.id === 15 ||
          service.id === 3 ||
          service.id === 7,
      );

      foodService = data?.data?.data?.activeServices?.find(
        (service) => service.id === 8 || service.id === 1 || service.id === 2,
      );
      activitiesService = data?.data?.data?.activeServices?.find(
        (service) => service.id === 31,
      );
      externalService = data?.data?.data?.activeServices?.find(
        (service) =>
          // service.id === 25 ||
          service.id === 9 ||
          service.id === 10 ||
          service.id === 11 ||
          service.id === 16 ||
          service.id === 13 ||
          service.id === 24 ||
          service.id === 6 ||
          service.id === 21 ||
          service.id === 14 ||
          service.id === 32 ||
          service.id === 34,
      );

      displayQuickServices = data?.data?.data?.activeServices?.find(
        (service) => service.id === 26,
      );

      const arrays = [
        spaWellnessService,
        hotelService,
        foodService,
        externalService,
        activitiesService,
        newsService,
      ];

      const nonEmptyArrays = arrays.filter((array) => array);

      if (nonEmptyArrays.length === 1) {
        isOneArrayContentItems = true;
      } else {
        isOneArrayContentItems = false;
      }

      headerImages = menu.realvideo
        ? [{ image: menu?.realvideo }, ...menu?.header_images]
        : menu?.header_images;
    }
  }
  console.log(services, "newsServicenewsServicenewsService");
  const getGreeting = () => {
    const currentHour = new Date().getHours();

    if (currentHour >= 6 && currentHour < 12) {
      return t("Good Morning");
    } else if (currentHour >= 12 && currentHour < 18) {
      return t("Good Afternoon");
    } else if (currentHour >= 18 && currentHour < 24) {
      return t("Good Evening");
    } else {
      return "Hello";
    }
  };
  const changeLang = (code) => {
    const previousLang = i18n.language || localStorage.getItem("lang") || "EN";
    getQuickServices(code);
    setShowSelect(false);
    setShowContent(false);
    localStorage.setItem("open_lang", "false");
    localStorage.setItem("lang", code);
    i18n.changeLanguage(code);

    // Track Language Changed in Mixpanel
    trackLanguageChanged({
      from_language: previousLang,
      to_language: code,
    });

    setTimeout(() => {
      setOpenLang("false");
      setShowContent(true);
    }, 8000);
  };

  let langArray = [];
  languages?.map((language) => {
    if (language.code == "EN") {
      langArray.push({ ...language, name: "English" });
    }
    if (language.code == "AR") {
      langArray.push({ ...language, name: "العربية" });
    }
    if (language.code == "FR") {
      langArray.push({ ...language, name: "Français" });
    }
    if (language.code == "RU") {
      langArray.push({ ...language, name: "Русский" });
    }
    if (language.code == "DE") {
      langArray.push({ ...language, name: "Deutsch" });
    }
    if (language.code == "CH") {
      langArray.push({ ...language, name: "中文" });
    }
    if (language.code == "HI") {
      langArray.push({ ...language, name: "한국어" });
    }
    if (language.code == "JA") {
      langArray.push({ ...language, name: "日本語" });
    }
    if (language.code == "PH") {
      langArray.push({ ...language, name: "Filipino" });
    }
    if (language.code == "ES") {
      langArray.push({ ...language, name: "Español" });
    }
    if (language.code == "CH-Hant") {
      langArray.push({ ...language, name: "繁體中文" });
    }
    if (language.code == "CH-Hans") {
      langArray.push({ ...language, name: "简体中文" });
    }
    if (language.code == "KO") {
      langArray.push({ ...language, name: "한국어" });
    }
  });

  const getQuickServices = (lang) => {
    axios
      .get(`/${params.room_uuid}/quick-services`, {
        headers: {
          lang: lang,
        },
      })
      .then((res) => {
        console.log(res.data.data);
        const data = res.data.data;
        setquickServices(data.quickServices);
      });
  };
  useEffect(() => {
    getQuickServices(lang);
  }, []);

  // Show popup when data loads with video or image or text
  useEffect(() => {
    if (!isLoading && data?.data?.data) {
      const menu = data.data.data;
      if (menu.real_popup_video) {
        setPopupMedia({ type: "video", src: menu.real_popup_video });
        setPopupOpen(true);
      } else if (menu.real_popup_image) {
        setPopupMedia({ type: "image", src: menu.real_popup_image });
        setPopupOpen(true);
      } else if (menu.real_popup_text) {
        setPopupMedia({ type: "text", src: menu.real_popup_text });
        setPopupOpen(true);
      }
    }
  }, [isLoading, data]);

  return (
    <div className={`new_page ${lang == "AR" && "arabic"}`}>
      {isLoading ? (
        <NewLoader />
      ) : (
        <>
          <div className={`box_lang ${openLang == "true" ? "" : "not_show"}`}>
            <Zoom>
              <div className="logo">
                <img src={logo} alt="" className="adress_logo" />
              </div>
            </Zoom>
            {showSelect ? (
              <>
                <Zoom>
                  <h4>{t("Please select your language to begin")}</h4>
                </Zoom>
                <ul className="languages_list">
                  {langArray.map((item, idx) => {
                    return (
                      <Bounce buttom duration={1000} delay={500} key={idx}>
                        <li
                          onClick={() => changeLang(item.code)}
                          className={item.code == lang ? "lang_active" : ""}
                        >
                          {item.name}
                        </li>
                      </Bounce>
                    );
                  })}
                </ul>
              </>
            ) : (
              <>
                <Bounce buttom duration={1000} delay={200}>
                  <h4 className="welcome_title">{getGreeting()}</h4>
                </Bounce>
                <Zoom buttom duration={1000} delay={800}>
                  <p className="welocome">
                    {" "}
                    <ReactTyped strings={[t(welcomeMessage)]} typeSpeed={50} />
                  </p>
                </Zoom>
              </>
            )}
          </div>
          {showContent && (
            <>
              <BannerHome
                className={"dot-bar less-margin small-dots"}
                isFirst={true}
                isVideo={true}
                headerImages={headerImages}
                bannerWithAdditional={true}
              />
              {active_flexipass && active_flexipass !== "false" && (
                <div className="themed">
                  <div className="flexi-container">
                    <div className=" flexi-text-area">
                      <p className="prim-text">
                        Use your mobile device to securely unlock your room
                        door.
                      </p>
                      {/* <p className="sub-text">Subtext test</p> */}
                    </div>

                    <button
                      className="flexi-btn"
                      onClick={() => setDoorConfirmOpen(true)}
                      disabled={doorLoading}
                    >
                      {doorLoading ? t("Unlocking...") : t("Unlock Room Door")}
                    </button>
                  </div>
                </div>
              )}
              <div className="quick_services">
                {showServices ? (
                  <div className="services_box">
                    {quickServices?.map((item) => {
                      return (
                        <span
                          key={item.id}
                          onClick={() => {
                            if (
                              item.name.includes("Feedback / Complaint") ||
                              item.name.includes("Hotel Review") ||
                              item.name.includes("Review / Complaint") ||
                              item.name.includes("Review") ||
                              item.name.includes("Feedback") ||
                              item.id == 4 ||
                              item.id == 7
                            ) {
                              navigate(`/${params.room_uuid}/feedback`);
                            } else {
                              selectQuickService(item.id);
                            }
                          }}
                        >
                          {t(`${item.name}`)}
                        </span>
                      );
                    })}
                  </div>
                ) : displayQuickServices ? (
                  <button onClick={(e) => setShowServices(true)}>
                    {t("Quick Services")}
                  </button>
                ) : null}
              </div>
              <div className="our_offering">
                <h3>{t("Explore Our Offerings")}</h3>

                {isOneArrayContentItems ? (
                  <div className="box_slider">
                    {foodService && (
                      <div
                        className="image_carousel"
                        onClick={() =>
                          navigate(`/${params.room_uuid}/food-and-beverages`, {
                            state: {
                              metadata: services,
                            },
                          })
                        }
                      >
                        {businessName === "Al Safwah Hotel Third Tower" ||
                        businessName === "Al Safwah Hotel First Tower" ? (
                          <img src={FoodServiceImage} alt="" />
                        ) : (
                          <img src={Food} alt="" />
                        )}
                        <img src={Rectangle} alt="" className="img_overlay" />
                        <h6 className="img_title">{t("Food & Beverages")}</h6>
                      </div>
                    )}

                    {hotelService && (
                      <Link
                        to={`/${params.room_uuid}/hotel-services`}
                        state={{ metadata: services }}
                        className="image_carousel"
                      >
                        {businessName === "Al Safwah Hotel Third Tower" ||
                        businessName === "Al Safwah Hotel First Tower" ? (
                          <img src={HotelServicesImage} alt="" />
                        ) : (
                          <img src={hotelServicesCardImage} alt="" />
                        )}
                        <img src={Rectangle} alt="" className="img_overlay" />
                        <h6 className="img_title">{t("Hotel Services")}</h6>
                      </Link>
                    )}
                    {spaWellnessService && (
                      <Link
                        to={`/${params.room_uuid}/spa-wellness`}
                        state={{ metadata: services }}
                        className="image_carousel"
                      >
                        <img src={Spa} alt="" />
                        <img src={Rectangle} alt="" className="img_overlay" />
                        <h6 className="img_title">{t("Spa & Wellness")}</h6>
                      </Link>
                    )}

                    {data?.data?.data?.activeServices?.find(
                      (service) => service.id === 31,
                    ) && (
                      <Link
                        to={`/${params.room_uuid}/activities`}
                        state={{ metadata: services }}
                        className="image_carousel"
                      >
                        <img
                          src={
                            activitiesService.service_name.includes(
                              "City Guide",
                            )
                              ? Cityguide
                              : Activities
                          }
                          alt=""
                        />
                        <img src={Rectangle} alt="" className="img_overlay" />
                        <h6 className="img_title">
                          {activitiesService.display_name}
                        </h6>
                      </Link>
                    )}
                    {externalService && (
                      <Link
                        to={`/${params.room_uuid}/external-services`}
                        state={{ metadata: services }}
                        className="image_carousel"
                      >
                        {businessName === "Al Safwah Hotel Third Tower" ||
                        businessName === "Al Safwah Hotel First Tower" ? (
                          <img src={ExternalServiceImage} alt="" />
                        ) : (
                          <img src={Taxi} alt="" />
                        )}
                        <img src={Rectangle} alt="" className="img_overlay" />
                        <h6 className="img_title">{t("External Services")}</h6>
                      </Link>
                    )}
                  </div>
                ) : (
                  <Slider {...settings}>
                    {foodService &&
                    !businessName.includes(
                      "C Central Hotel & Resort The Palm",
                    ) &&
                    !businessName.includes(
                      "Canal Central Hotel Business Bay",
                    ) &&
                    !businessName.includes(
                      "Royal Central Hotel and Resort The Palm",
                    ) ? (
                      <div
                        className="image_carousel"
                        onClick={() =>
                          navigate(`/${params.room_uuid}/food-and-beverages`, {
                            state: {
                              metadata: services,
                            },
                          })
                        }
                      >
                        {businessName === "Al Safwah Hotel Third Tower" ||
                        businessName === "Al Safwah Hotel First Tower" ? (
                          <img src={FoodServiceImage} alt="" />
                        ) : (
                          <img src={Food} alt="" />
                        )}
                        <img src={Rectangle} alt="" className="img_overlay" />
                        <h6 className="img_title">{t("Food & Beverages")}</h6>
                      </div>
                    ) : (
                      services.map((service) => {
                        if (service.id === 2) {
                          return (
                            <div
                              className="image_carousel"
                              onClick={() =>
                                navigate(
                                  `/${params.room_uuid}/food-and-beverages/restaurant-booking`,
                                )
                              }
                            >
                              <img src={Booking} alt="" />
                              <img
                                src={Rectangle}
                                alt=""
                                className="img_overlay"
                              />
                              <h6 className="img_title">
                                {service?.display_name}
                              </h6>
                            </div>
                          );
                        }

                        if (service.id === 1) {
                          return (
                            <div
                              className="image_carousel"
                              onClick={() =>
                                navigate(
                                  `/${params.room_uuid}/food-and-beverages/in-room-dining`,
                                )
                              }
                            >
                              <img src={Dining} alt="" />
                              <img
                                src={Rectangle}
                                alt=""
                                className="img_overlay"
                              />
                              <h6 className="img_title">
                                {service?.display_name}
                              </h6>
                            </div>
                          );
                        }
                      })
                    )}

                    {hotelService && (
                      <Link
                        to={`/${params.room_uuid}/hotel-services`}
                        state={{ metadata: services }}
                        className="image_carousel"
                      >
                        {businessName === "Al Safwah Hotel Third Tower" ||
                        businessName === "Al Safwah Hotel First Tower" ? (
                          <img src={HotelServicesImage} alt="" />
                        ) : (
                          <img src={hotelServicesCardImage} alt="" />
                        )}
                        <img src={Rectangle} alt="" className="img_overlay" />
                        <h6 className="img_title">{t("Hotel Services")}</h6>
                      </Link>
                    )}

                    {spaWellnessService && (
                      <Link
                        to={`/${params.room_uuid}/spa-wellness`}
                        state={{ metadata: services }}
                        className="image_carousel"
                      >
                        <img src={Spa} alt="" />
                        <img src={Rectangle} alt="" className="img_overlay" />
                        <h6 className="img_title">{t("Spa & Wellness")}</h6>
                      </Link>
                    )}
                    {data?.data?.data?.activeServices?.find(
                      (service) => service.id === 31,
                    ) && (
                      <Link
                        to={`/${params.room_uuid}/activities`}
                        state={{ metadata: services }}
                        className="image_carousel"
                      >
                        <img
                          src={
                            activitiesService.service_name.includes(
                              "City Guide",
                            )
                              ? Cityguide
                              : Activities
                          }
                          alt=""
                        />
                        <img src={Rectangle} alt="" className="img_overlay" />
                        <h6 className="img_title">
                          {activitiesService.display_name}
                        </h6>
                      </Link>
                    )}

                    {hotelInformation &&
                      (businessName.includes(
                        "C Central Hotel & Resort The Palm",
                      ) ||
                        businessName.includes(
                          "Canal Central Hotel Business Bay",
                        ) ||
                        businessName.includes(
                          "Royal Central Hotel and Resort The Palm",
                        )) && (
                        <Link
                          to={`/${hotelInformation.link}`}
                          className="image_carousel"
                        >
                          <img src={Hoteinfo} alt="" />
                          <img src={Rectangle} alt="" className="img_overlay" />
                          <h6 className="img_title">
                            {hotelInformation.display_name || t("activities")}
                          </h6>
                        </Link>
                      )}

                    {externalService && (
                      <Link
                        to={`/${params.room_uuid}/external-services`}
                        state={{ metadata: services }}
                        className="image_carousel"
                      >
                        {businessName === "Al Safwah Hotel Third Tower" ||
                        businessName === "Al Safwah Hotel First Tower" ? (
                          <img src={ExternalServiceImage} alt="" />
                        ) : (
                          <img src={Taxi} alt="" />
                        )}
                        <img src={Rectangle} alt="" className="img_overlay" />
                        <h6 className="img_title">{t("External Services")}</h6>
                      </Link>
                    )}

                    {newsService && (
                      <Link
                        to={`/${params.room_uuid}/external-services/things-to-do`}
                        className="image_carousel"
                      >
                        {businessName === "Al Safwah Hotel Third Tower" ||
                        businessName === "Al Safwah Hotel First Tower" ? (
                          <img src={ENewsServiceImage} alt="" />
                        ) : (
                          <img src={News} alt="" className="" />
                        )}
                        <img src={Rectangle} alt="" className="img_overlay" />
                        <h6 className="img_title">
                          {newsService?.display_name}
                        </h6>
                      </Link>
                    )}
                    {sustainablityService && (
                      <a
                        href={sustainablityService.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="image_carousel"
                      >
                        <img src={Sustainability} alt="" />
                        <img src={Rectangle} alt="" className="img_overlay" />
                        <h6 className="img_title">
                          {sustainablityService.display_name}
                        </h6>
                      </a>
                    )}
                  </Slider>
                )}
              </div>
              <div className="language_box">
                <div
                  className="btn_lang"
                  onClick={() => {
                    setOpenLang("true");
                    setShowSelect(true);
                  }}
                >
                  {lang}
                </div>
              </div>
              <NewFooter />
            </>
          )}
        </>
      )}
      <Toast ref={toast} position="top-right" />

      <Modal
        show={doorConfirmOpen}
        onHide={() => setDoorConfirmOpen(false)}
        backdrop="static"
        className={`${theme && "food-modal"} rate_modal q_services_modal p-0`}
        style={{
          minHeight: "150px",
          padding: "0px !important",
          display: "flex !important",
          alignItems: "center !important",
          paddingRight: "0 !important",
        }}
      >
        <Modal.Body style={{ padding: "20px 10px", height: "auto" }}>
          <img
            src={Flexi}
            alt="Optemai Access"
            style={{
              width: "100%",
              maxHeight: "30px",
              objectFit: "contain",
              marginBottom: "12px",
            }}
          />
          <h5 style={{ color: theme ? "#e7e7e7" : "var(--color)" }}>
            {t("Are you sure you want to unlock your room door?")}
          </h5>
          <div className="servi_btns">
            <Button
              disabled={doorLoading}
              className="no"
              style={{
                borderColor: theme ? "#ffd28d" : "var(--color)",
                color: theme ? "#ffd28d" : "var(--color)",
              }}
              onClick={() => setDoorConfirmOpen(false)}
            >
              {t("No")}
            </Button>
            <Button
              disabled={doorLoading}
              className="yes"
              style={{
                background: theme ? "#ffd28d" : "var(--color)",
                borderColor: theme ? "#ffd28d" : "var(--color)",
                color: theme ? "#000" : "#fff",
              }}
              onClick={unlockDoor}
            >
              {t("Yes")}
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={open}
        onHide={handleClose}
        backdrop="static"
        className={`food-modal rate_modal q_services_modal p-0`}
        style={{
          minHeight: "150px",
          padding: "0px !important",
          display: "flex !important",
          alignItems: "center !important",
          paddingRight: "0 !important",
        }}
      >
        <Modal.Body style={{ padding: "20px 10px", height: "auto" }}>
          <h5>{t("Are you sure you want to submit the request?")} </h5>

          <div className="servi_btns">
            <Button
              disabled={loading}
              className="no"
              onClick={() => setOpen(false)}
            >
              {t("No")}
            </Button>
            <Button
              disabled={loading}
              className="yes"
              onClick={bookQuickService}
            >
              {t("Yes")}
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      {/* Popup Modal for Video/Image */}
      <Modal
        show={popupOpen}
        onHide={() => setPopupOpen(false)}
        className="food-modal banner_popup p-0"
        style={{
          marginTop: "10px",
          minHeight: "160px ",
          padding: "0px !important",
          display: "flex !important",
          alignItems: "center !important",
          paddingRight: "0 !important",
        }}
      >
        <Modal.Body style={{ padding: "20px 10px", height: "75vh" }}>
          <div>
            <button
              onClick={() => setPopupOpen(false)}
              className="popup-close-btn"
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                border: "none",
                background: "black",
                color: "#ffd18c",
                width: "35px",
                height: "35px",
                borderRadius: "50%",
                fontSize: "10px",
                padding: "5px",
                fontWeight: "bold",
                cursor: "pointer",
                zIndex: 10,
              }}
            >
              <svg
                className="w-5 h-5 text-gray-400"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>
          </div>
          <div style={{ width: "100%", height: "100%", position: "relative" }}>
            {popupMedia.type === "video" && (
              <video
                width="100%"
                height="100%"
                style={{ objectFit: "cover", minHeight: "100%" }}
                autoPlay
                muted
                playsInline
                loop={true}
              >
                <source src={popupMedia.src} type="video/mp4" />
              </video>
            )}
            {popupMedia.type === "image" && (
              <img src={popupMedia.src} alt="Popup" style={{ width: "100%" }} />
            )}
            {popupMedia.type === "text" && (
              <p style={{ textAlign: "center", color: "#fff" }}>
                {popupMedia.src}
              </p>
            )}
            {/* <div className="banner-book" style={{ marginTop: "15px" }}>
              <a onClick={() => setPopupOpen(false)}>{t("Dismiss")}</a>
            </div> */}
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default NewHome;
